<template>
  <v-container>
    <btn-a
      class="ma-2"
      outlined
      rounded
      color="primary"
      @click="itemDialogOpen"
    >
      <v-icon>mdi-plus</v-icon>
    </btn-a>
    <v-progress-linear v-if="loading" indeterminate></v-progress-linear>
    <v-list two-line subheader v-if="value.jobStageItemProds" loading>
      <div v-for="(item, i) in value.jobStageItemProds" :key="i">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{ getDescItem(item) }}</v-list-item-title>
            <v-list-item-subtitle
              >{{ $t("entities.jobStageItemProd.props.qtEstimated") }}:{{
                item.qtEstimated
              }}
              | {{ $t("entities.jobStageItemCons.props.qtReal") }}:
              {{ item.qtReal }}</v-list-item-subtitle
            >
          </v-list-item-content>
          <v-list-item-action>
            <v-btn icon @click="itemDialogOpen(item)">
              <v-icon color="warning">mdi-pencil</v-icon>
            </v-btn>
          </v-list-item-action>
          <v-list-item-action>
            <v-btn icon @click="itemRemove(item)">
              <v-icon color="error">mdi-delete</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-divider
          v-if="value.item && value.jobStageItemProds.length > 0"
        ></v-divider>
      </div>
    </v-list>
    <dialog-d
      ref="itemDialog"
      title="item"
      @confirm="itemConfirm"
      @cancel="itemDialogCancel"
    >
      <jobStageItemProdForm ref="form" v-model="selectedItem" />
    </dialog-d>
  </v-container>
</template>


<script>
import jobStageItemProdForm from "./jobStageItemProdForm";
export default {
  components: { jobStageItemProdForm },
  props: {
    value: {
      default: () => {
        return {
          jobStageItemProds: []
        };
      }
    }
  },
  data() {
    return {
      loading: false,
      items: [],
      selectedItem: {},
      selectedItemRef: null
    };
  },

  watch: {
    async value() {
      await this.getItemsByIds();
    }
  },
  methods: {
    async getItemsByIds() {
      if (this.value.jobStageItemProds.length == 0) return;
      this.loading = true;
      let itemIds = [];
      this.value.jobStageItemProds.forEach(i => itemIds.push(i.itemId));
      let res = await this.$http.get("item/s-ids?ids=" + itemIds.toString());
      if (res.success) this.items = res.data;
      this.loading = false;
    },
    getDescItem(value) {
       let item = this.items != null ? this.items.filter(i => i.id == value.itemId)[0] : null;
      return item ? item.description : value.itemDescription;
    },
    itemDialogCancel() {
      this.selectedItemRef = null;
    },
    async itemConfirm() {
      if (!this.$refs.form.isValid()) return;
      for (let items in this.selectedItem){
        if ( isNaN(this.selectedItem[items]) && this.selectedItem[items].includes(',')){
           this.selectedItem[items] = this.selectedItem[items].replace(',' , '.');
        }
      }
      if (this.selectedItemRef) {
        Object.assign(this.selectedItemRef, this.selectedItem);
      } else {
        this.value.jobStageItemProds.push(this.selectedItem);
      }
      this.$refs.itemDialog.open();
      this.selectedItemRef = null;

      await this.getItemsByIds();
    },
    async itemRemove(item) {
         if(!(await this.$confirm())) return;
      let index = this.value.jobStageItemProds.indexOf(item);
      if (index >= 0) this.value.jobStageItemProds.splice(index, 1);
    },
    itemDialogOpen(item) {
      if (item) {
        this.selectedItemRef = item;
        let obj = {};
        Object.assign(obj, item);
        this.selectedItem = obj;
      } else {
        this.selectedItem = { itemId: null };
      }

      this.$refs.itemDialog.open();
    }
  },
  created() {
    if (!this.value.jobStageItemProds) this.value.jobStageItemProds = [];
  },
  async mounted() {
    if (!this.value.jobStageItemProds) this.value.jobStageItemProds = [];
    await await this.getItemsByIds();
  }
};
</script>